var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.getPlantImages),function(plantImage,plantImageIdx){return _c('div',{key:'plant-image-' + plantImageIdx,staticClass:"box"},[_c('GalleryItem',{attrs:{"image":plantImage}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }